import {
    LOGIN_USER,
    LOGOUT_USER,
    STORE_SEARCH,
    CLEAR_STORE_SEARCH,
    REQUEST_ADD_INDIVIDUAL_PENDING,
    REQUEST_ADD_INDIVIDUAL_SUCCESS,
    REQUEST_ADD_INDIVIDUAL_CLEAR
} from "../actiontypes";

import ApiPath from "../utils/Apis/ApiPath";
import history from "../utils/Routing/history";

//! LOGIN PAGE ACTION CREATOR
// Gets Login Data And Tokens
export const userLoginFetch = () => async (dispatch, getState) => {
    let email, password;
    const formValues = getState().form.loginForm.values;
    if (formValues) {
        email = formValues.email ? formValues.email : "";
        password = formValues.password ? formValues.password : "";
    } else {
        email = "";
        password = "";
    }

    const baseURL = `${ApiPath.urlApi}/api/login/loginUser?`;
    const response = await fetch(
        `${baseURL}db=${ApiPath.db}&uname=${email}&pword=${password}&type=json`
    );

    const responseParsed = await response.json();
    if (
        responseParsed.loginSuccess === false ||
        responseParsed.message === "An error has occurred."
    ) {
        alert("Wrong email or password");
        dispatch({ type: LOGIN_USER, payload: { loggedIn: false, user: {} } });
        history.push("/login");
    } else {
        const payloadObj = {
            loggedIn: true,
            user: {
                uname: responseParsed.uname,
                overrideEnabled: responseParsed.overrideEnabled,
                userId: responseParsed.user_id
            }
        };
        dispatch({ type: LOGIN_USER, payload: payloadObj });
        history.push("/");
    }
};

export const getProfileFetch = validating => async dispatch => {
    const token = localStorage.token;
    if (token) {
        const response = await fetch("http://localhost:5000/auth/verifyToken", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        });

        const responseParsed = await response.json();

        if (responseParsed.message) {
            localStorage.removeItem("token");

            dispatch({
                type: LOGIN_USER,
                payload: { loggedIn: false, user: {} }
            });

            if (validating) {
                return;
            }

            // SET LOGGED IN TO FALSE
            history.push("/");

            // Logged In Immediate (FALSE)
            //return false;
        } else {
            const payloadObj = {
                loggedIn: true,
                user: {
                    token: token,
                    userId: responseParsed.userId
                }
            };

            dispatch({ type: LOGIN_USER, payload: payloadObj });

            // history.push("/");
            //return true;
        }
    } else {
        dispatch({
            type: LOGIN_USER,
            payload: { loggedIn: false, user: {} }
        });

        if (validating) {
            return;
        }
        history.push("/");

        //TODO: I AM GETTING HERE
        //return false;
    }
};

export const logoutUser = () => {
    localStorage.removeItem("token");

    return {
        type: LOGOUT_USER,
        payload: { loggedIn: false }
    };
};

//* Search Caching
export const storeSearch = data => {
    return {
        type: STORE_SEARCH,
        payload: data
    };
};

export const clearStoreSearch = () => {
    return {
        type: CLEAR_STORE_SEARCH
    };
};

// Add Individual Attendee
export const addIndividualAttendee =
    (fname, lname, email, group_attnum, event_id) =>
    async (dispatch, getState) => {
        const { sessionId, companyId } = getState().user.user;

        dispatch({ type: REQUEST_ADD_INDIVIDUAL_PENDING });

        const baseURL = `${ApiPath.urlApi}/api/attendeeInsert/insertNewAttendeeToEvent?`;
        const response = await fetch(
            `${baseURL}db=${ApiPath.db}&fname=${fname}&lname=${lname}&email=${email}&group_attnum=${group_attnum}&event_id=${event_id}&type=json&SessionId=${sessionId}&CompId=${companyId}`,
            {
                method: "POST"
            }
        );

        const responseParsed = await response.json();

        console.log(responseParsed);
        if (responseParsed === "Yay") {
            dispatch({ type: REQUEST_ADD_INDIVIDUAL_SUCCESS });
        } else {
            alert("Could not add");
        }
    };

export const clearAddIndividualAttendee = () => {
    return {
        type: REQUEST_ADD_INDIVIDUAL_CLEAR
    };
};

//export const userLoginFetchOriginal = () => {
//~ DAVE REQUEST VERSION
// const validU = ["adelguerico@xyvid.com", "rlloyd@xyvid.com"];
// const validP = "XyvidAdmin2020";

// if (validU.includes(email) && password === validP) {
//     const payloadObj = {
//         loggedIn: true,
//         user: {
//             token: "",
//             userId: ""
//         }
//     };
//     dispatch({ type: LOGIN_USER, payload: payloadObj });
//     history.push("/");
// } else {
//     alert("Wrong email or password");
//     dispatch({ type: LOGIN_USER, payload: { loggedIn: false, user: {} } });
//     history.push("/login");
// }

//~ TOKEN VERSION
// let email, password;
// const formValues = getState().form.loginForm.values;
// if (formValues) {
//     email = formValues.email ? formValues.email : "";
//     password = formValues.password ? formValues.password : "";
// } else {
//     email = "";
//     password = "";
// }

// const response = await fetch("http://localhost:5000/auth/login", {
//     method: "POST",
//     headers: {
//         "Content-Type": "application/json"
//         // Accept: "application.json"
//     },
//     body: JSON.stringify({
//         email: email,
//         password: password
//     })
// });
// const responseParsed = await response.json();
// if (responseParsed.message === "FAILED") {
//     alert("Wrong email or password");
//     dispatch({ type: LOGIN_USER, payload: { loggedIn: false, user: {} } });
//     history.push("/login");
// } else {
//     localStorage.setItem("token", responseParsed.token);
//     const payloadObj = {
//         loggedIn: true,
//         user: {
//             token: responseParsed.token,
//             userId: responseParsed.userId
//         }
//     };
//     dispatch({ type: LOGIN_USER, payload: payloadObj });
//     history.push("/");
// }
//}
